import { Button } from '@/components/button/button';
import Download from '@/assets/icons/file-05.svg?react';
import { Tooltip } from 'antd/lib';
import { useTranslation } from 'react-i18next';

interface ExportButtonProps {
  onPrepareExport: () => void;
  isMobile: boolean;
  isExporting?: boolean;
  isEmptyData?: boolean;
  isDisabled?: boolean;
  /** The conversations toolbar opens the export history rather than starting an export, so
   *  it reuses this chrome under its own label. */
  label?: string;
  tooltip?: string;
}

export function ExportButton({
  onPrepareExport,
  isMobile,
  isExporting = false,
  isEmptyData = false,
  isDisabled,
  label,
  tooltip,
}: ExportButtonProps) {
  const { t } = useTranslation('conversations');
  const title = isEmptyData ? t('export.noData') : (tooltip ?? '');

  return (
    <Tooltip title={title}>
      <div>
        <Button
          loading={isExporting}
          disabled={isDisabled || isEmptyData}
          rightIcon
          onClick={onPrepareExport}
          icon={<Download style={{ width: 10, height: 10 }} />}
          style={{
            margin: 'auto',
            fontSize: 14,
            fontWeight: 400,
            padding: isMobile ? '0px 5px' : '0px 12px',
          }}
          buttonVariant="secondary"
        >
          {label ?? t('export.prepare')}
        </Button>
      </div>
    </Tooltip>
  );
}
